<template>
  <div id="app">
    <navbar></navbar>
	  <div id="top"></div>
    <div class="wrapper">
      <app-header></app-header>
      <services></services>
      <pricing @open-form-family="openFormFamily" @open-form-care-facility="openFormCareFacility"></pricing>
      <howto></howto>
      <app-footer></app-footer>
    </div>
  </div>
</template>

<script>
import Navbar from './components/Navbar'
import AppHeader from './components/Header'
import Services from './components/Services'
import Pricing from './components/Pricing'
import Howto from './components/Howto'
import AppFooter from './components/Footer'

export default {
  name: 'App',
  data() {
    return {
      formFamily: false,
      formCareFacility: false
    }
  },
  components: {
    Navbar, AppHeader, Services, Howto, Pricing, AppFooter
  },
  methods: {
    openFormFamily() {

    },
    openFormCareFacility() {

    }
  },
  mounted() {
    // Add smooth scrolling to all links
    $("a").on('click', function(event) {

      // Make sure this.hash has a value before overriding default behavior
      if (this.hash !== "") {
        // Prevent default anchor click behavior
        event.preventDefault();

        // Store hash
        var hash = this.hash;

        // Using jQuery's animate() method to add smooth page scroll
        // The optional number (800) specifies the number of milliseconds it takes to scroll to the specified area
        $('html, body').animate({
          scrollTop: $(hash).offset().top
        }, 800, function(){

          // Add hash (#) to URL when done scrolling (default click behavior)
          window.location.hash = hash;
        });
      } // End if
    });
  }
}
</script>

<style>
@import url('https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css');
@import url('https://fonts.googleapis.com/css?family=Montserrat:300,400,500,600,700,800&display=swap');
@import url('https://fonts.googleapis.com/css?family=Poppins:300,400,500,600,700,800&display=swap');
@import url('https://fonts.googleapis.com/icon?family=Material+Icons');

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
